import { Anchor } from 'components/UI/Anchor'
import { OverflownText } from 'components/OverflownText'

/**
 * External-link variant of TruncatedLinkCell: a single-line, ellipsized
 * `<Anchor>` that shows the full value in a styled tooltip on hover when it
 * overflows — matching how company-name links (TruncatedLinkCell) behave.
 *
 * Used for domain / Instagram-handle (and similar) link columns. `text` is both
 * the display label and the tooltip; `href` is the link target.
 */
export const TruncatedExternalLinkCell = ({
  text,
  href,
  target = '_blank',
}: {
  text: string
  href: string
  target?: string
}) => {
  return (
    <div className="max-w-full" style={{ minWidth: 0, flex: 1 }}>
      <OverflownText tooltipText={text}>
        <div
          style={{
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          <Anchor href={href} target={target}>
            {text}
          </Anchor>
        </div>
      </OverflownText>
    </div>
  )
}
